import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import styles from "./ProjectSelector.module.css";
import { Button } from "../common/Button";
import { isShareProject } from "../../data/projectLoader";

interface Project {
  name: string;
  imageCount: number;
  coverImage: {
    filename: string;
    path: string | null;
  } | null;
  path: string;
}

interface ProjectSelectorProps {
  projects: Project[];
  selectedProject: string | null;
  onSelectProject: (projectName: string | null) => void;
}

export const ProjectSelector: React.FC<ProjectSelectorProps> = ({
  projects,
  selectedProject,
  onSelectProject
}) => {
  const { t } = useLanguage();

  // Filter out root project AND share projects
  const filteredProjects = projects.filter((p) =>
    p.name !== "root" && !isShareProject(p.name) && !p.path.includes('share-')
  );

  if (filteredProjects.length === 0) {
    return null;
  }

  const formatProjectName = (name: string): string => {
    return name.replace(/-/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
  };

  return (
    <div className={styles.projectSelector}>
      <div className={styles.container}>
        <Button
          variant={selectedProject === null ? "primary" : "ghost"}
          onClick={() => onSelectProject(null)}
        >
          {t("nav.allWork")}
        </Button>
        {filteredProjects.map((project) => (
          <Button
            key={project.name}
            variant={selectedProject === project.name ? "primary" : "ghost"}
            onClick={() => onSelectProject(project.name)}
          >
            {formatProjectName(project.name)}
            <span className={styles.imageCount}>{project.imageCount}</span>
          </Button>
        ))}
      </div>
    </div>
  );
};
